
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/basic-elements/cookie-hinweis",
      function () {
        return require("private-next-pages/basic-elements/cookie-hinweis.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/basic-elements/cookie-hinweis"])
      });
    }
  